import { render, staticRenderFns } from "./Laboratory.vue?vue&type=template&id=0e548fc6&scoped=true&lang=pug&"
import script from "./Laboratory.vue?vue&type=script&lang=coffee&"
export * from "./Laboratory.vue?vue&type=script&lang=coffee&"
import style0 from "./Laboratory.vue?vue&type=style&index=0&id=0e548fc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e548fc6",
  null
  
)

component.options.__file = "Laboratory.vue"
export default component.exports